import { TOTAL } from "./constants"
import {
  ChartElements,
  Gender,
  IncomeGroup,
  Region,
  Urbanization,
} from "./enum"

export const COLOR = {
  blue01: '#0AA3DC',
  blue02: '#081079',
  blue03: '#106CA1',
  blue04: '#163C6C',
  blue05: '#80D2E8',
  blue06: '#80C9E8',
  blue07: '#34a7f2',
  blue08: '#0071BC',
  blue09: '#053657',
  blue10: '#0186C0',
  blue11: '#ACE1F4',
  blue12: '#009FDA',
  orange01: '#FF9800',
  orange02: '#C2660D',
  orange03: '#FFD554',
  orange04: '#8F3B18',
  orange05: '#EB6E51',
  orange06: '#FF9E75',
  violet01: '#664AB6',
  violet02: '#B38FD8',
  violet03: '#462F98',
  violet04: '#6D88D1',
  violet05: '#A1C6FF',
  violet06: '#3B4DA6',
  violet07: '#8963C1',
  green01: '#4EC2C0',
  green02: '#0C7C68',
  green03: '#228B8B',
  green04: '#084D31',
  green05: '#006061',
  green06: '#54AE89',
  green07: '#95E2E2',
  green08: '#9ADEAA',
  green09: '#016B6C',
  green10: '#73af48',
  green11: '#7B7C13',
  green12: '#4E5200',
  yellow01: '#DDDA21',
  yellow02: '#ABAA22',
  pink01: '#F3578E',
  pink02: '#BB3B64',
  pink03: '#F8A8DF',
  pink04: '#EDC2F1',
  pink05: '#db95d7',
  red01: '#AA0000',
  red02: '#801E37',
  red03: '#D43729',
  gray01: '#666666',
  gray02: '#CED4DE',
  gray03: '#8A969F',
  gray04: '#EFF2F5',
  black01: '#111111',
  black02: '#333333',
  black03: '#000000',
  white: '#FFFFFF',
  darkGray: '#212121',
}

export const COLOR_MAP = {
  benchmark: COLOR.gray01,
  highlight: COLOR.black01,
  [TOTAL]: COLOR.blue04,
  [Gender.Male]: COLOR.violet01,
  [Gender.Female]: COLOR.orange01,
  [Gender.NonResponse]: COLOR.green01,
  [Gender.Other]: COLOR.green01,
  [Gender.Unknown]: COLOR.green01,
  [Gender.NotApplicable]: COLOR.green01,
  [Urbanization.Rural]: COLOR.green06,
  [Urbanization.Urban]: COLOR.violet04,

  age: [
    COLOR.pink03,
    COLOR.violet02,
    COLOR.violet03,
    COLOR.violet04,
    COLOR.violet05,
  ],

  [Region.NorthAmerica]: COLOR.blue07,
  [Region.Africa]: COLOR.orange01,
  [Region.MiddleEast]: COLOR.violet01,
  [Region.SouthAsia]: COLOR.green01,
  [Region.EastAsia]: COLOR.pink01,
  [Region.World]: COLOR.blue02,
  [Region.LatinAmerica]: COLOR.green02,
  [Region.Europe]: COLOR.red01,
  [Region.WestAfrica]: COLOR.yellow01,
  [Region.EastAfrica]: COLOR.orange01,

  [IncomeGroup.High]: COLOR.green09,
  [IncomeGroup.UpperMid]: COLOR.green10,
  [IncomeGroup.LowerMid]: COLOR.pink05,
  [IncomeGroup.Low]: COLOR.violet06,
  [IncomeGroup.UnClassified]: COLOR.gray01,

  [`${Region.NorthAmerica}_countries`]: [
    COLOR.blue01,
    COLOR.blue05,
    COLOR.blue04,
    COLOR.blue03,
  ],
  [`${Region.Africa}_countries`]: [
    COLOR.orange01,
    COLOR.orange03,
    COLOR.orange04,
    COLOR.orange02,
  ],
  [`${Region.EastAfrica}_countries`]: [
    COLOR.orange01,
    COLOR.orange03,
    COLOR.orange04,
    COLOR.orange02,
  ],
  [`${Region.WestAfrica}_countries`]: [
    COLOR.yellow01,
    COLOR.green11,
    COLOR.yellow02,
    COLOR.green12,
  ],
  [`${Region.MiddleEast}_countries`]: [
    COLOR.violet01,
    COLOR.violet02,
    COLOR.violet03,
    COLOR.pink04,
  ],
  [`${Region.SouthAsia}_countries`]: [
    COLOR.green01,
    COLOR.green03,
    COLOR.green05,
    COLOR.green07,
  ],
  [`${Region.EastAsia}_countries`]: [
    COLOR.pink01,
    COLOR.pink03,
    COLOR.pink02,
    COLOR.red02,
  ],
  [`${Region.LatinAmerica}_countries`]: [
    COLOR.green02,
    COLOR.green06,
    COLOR.green04,
    COLOR.green08,
  ],
  [`${Region.Europe}_countries`]: [
    COLOR.red01,
    COLOR.orange05,
    COLOR.orange06,
    COLOR.red03,
  ],

  category: [
    COLOR.blue07,
    COLOR.orange01,
    COLOR.violet01,
    COLOR.green01,
    COLOR.pink01,
    COLOR.blue02,
    COLOR.green02,
    COLOR.red01,
    COLOR.blue05,
    COLOR.orange03,
    COLOR.violet02,
    COLOR.green03,
    COLOR.pink03,
    COLOR.violet04,
    COLOR.green06,
    COLOR.orange05,
    COLOR.blue04,
    COLOR.orange04,
    COLOR.violet03,
    COLOR.green05,
    COLOR.pink02,
    COLOR.violet05,
    COLOR.green04,
    COLOR.orange06,
    COLOR.blue03,
    COLOR.orange02,
    COLOR.pink04,
    COLOR.green07,
    COLOR.red02,
    COLOR.violet06,
    COLOR.green08,
    COLOR.red03,
  ],

  countryAnalyticsMapCategory: {
    noReports: COLOR.gray02,
    lastYear: COLOR.blue09,
    last5Year: COLOR.blue10,
    older: COLOR.blue11,
  },
  not_available: COLOR.gray02,
  sequential_9: [
    '#FDF7DB',
    '#CCE2D2',
    '#A1CBCF',
    '#7DB2CB',
    '#5D99C2',
    '#4180B3',
    '#2868A0',
    '#135189',
    '#023B6F',
  ],
  sequential_7: [
    '#FDF7DB',
    '#BDDBD0',
    '#89BACD',
    '#5D99C2',
    '#3978AD',
    '#1A5991',
    '#023B6F',
  ],
  sequential_6: [
    '#FDF7DB',
    '#BDDBD0',
    '#89BACD',
    '#3978AD',
    '#1A5991',
    '#023B6F',
  ],
  sequential_5: ['#FDF7DB', '#A1CBCF', '#5D99C2', '#2868A0', '#023B6F'],
  sequential_4: ['#FDF7DB', '#A1CBCF', '#2868A0', '#023B6F'],
  sequential_3: ['#FDF7DB', '#5D99C2', '#023B6F'], //formed from sequential_5 with 0,2,4 index colors
  sequentialreverse_9: [
    '#E3F6FD',
    '#B0E0F8',
    '#91C5F0',
    '#89A8DE',
    '#8B8AC0',
    '#8C6C9A',
    '#88506E',
    '#7C3541',
    '#691B15',
  ],
  sequentialreverse_7: [
    '#E3F6FD',
    '#A3D7F7',
    '#8AB2E6',
    '#8B8AC0',
    '#8C638C',
    '#803E51',
    '#691B15',
  ],
  sequentialreverse_6: [
    '#FDF7DB',
    '#BDDBD0',
    '#89BACD',
    '#3978AD',
    '#1A5991',
    '#023B6F',
  ],
  sequentialreverse_5: ['#E3F6FD', '#91C5F0', '#8B8AC0', '#88506E', '#691B15'],
  sequentialreverse_4: ['#E3F6FD', '#91C5F0', '#88506E', '#691B15'],
  sequentialreverse_3: ['#E3F6FD', '#8B8AC0', '#691B15'],
  sequential_rev_9: [
    '#E3F6FD',
    '#B0E0F8',
    '#91C5F0',
    '#89A8DE',
    '#8B8AC0',
    '#8C6C9A',
    '#88506E',
    '#7C3541',
    '#691B15',
  ],
  sequential_rev_7: [
    '#E3F6FD',
    '#A3D7F7',
    '#8AB2E6',
    '#8B8AC0',
    '#8C638C',
    '#803E51',
    '#691B15',
  ],
  sequential_rev_6: [
    '#FDF7DB',
    '#BDDBD0',
    '#89BACD',
    '#3978AD',
    '#1A5991',
    '#023B6F',
  ],
  sequential_rev_5: ['#E3F6FD', '#91C5F0', '#8B8AC0', '#88506E', '#691B15'],
  sequential_rev_4: ['#E3F6FD', '#91C5F0', '#88506E', '#691B15'],
  sequential_rev_3: ['#E3F6FD', '#8B8AC0', '#691B15'],
  diverging_9: [
    '#920000',
    '#B34E1A',
    '#D18440',
    '#EBB978',
    '#EFEFEF',
    '#97CBED',
    '#58A2D7',
    '#2579B6',
    '#025288',
  ],
  diverging_7: [
    '#920000',
    '#BD6126',
    '#E3A763',
    '#EFEFEF',
    '#80BDE7',
    '#3587C3',
    '#025288',
  ],
  divergingreverse_9: [
    '#025288',
    '#2579B6',
    '#58A2D7',
    '#97CBED',
    '#EFEFEF',
    '#EBB978',
    '#D18440',
    '#B34E1A',
    '#920000',
  ],
  diverging_rev_9: [
    '#025288',
    '#2579B6',
    '#58A2D7',
    '#97CBED',
    '#EFEFEF',
    '#EBB978',
    '#D18440',
    '#B34E1A',
    '#920000',
  ],
  divergingreverse_7: [
    '#025288',
    '#3587C3',
    '#80BDE7',
    '#EFEFEF',
    '#E3A763',
    '#BD6126',
    '#920000',
  ],
  diverging_rev_7: [
    '#025288',
    '#3587C3',
    '#80BDE7',
    '#EFEFEF',
    '#E3A763',
    '#BD6126',
    '#920000',
  ],
  categorical: [COLOR.green01, COLOR.blue08],
  [ChartElements.ZeroLine]: COLOR.gray03,
  [ChartElements.GridLine]: COLOR.gray02,
  [ChartElements.MinorGridLineLogAxis]: COLOR.gray04,
  // theme, topic, country pages -- start
  selected_1: COLOR.blue08,
  selected_2: COLOR.violet07,
  selected_secondary: COLOR.gray03,
  selected_secondary_benchmark: COLOR.gray02,
  topicprofile_featuredind: [COLOR.blue08, COLOR.violet07],
  dataset_ind: [COLOR.blue08, COLOR.violet07],
  benchmarkLineColorWithOtherCountries: COLOR.gray03,
  // theme, topic, country pages -- end
  homePageIncomeGroupColors: {
    HIC: COLOR.blue12, // High-income
    UMC: '#3CBAC7', // Upper-middle-income
    LMC: '#BAE1C4', // Lower-middle-income
    LIC: '#FFF1D0', // Low-income
    NO_DATA: '#E4E9EC', // No data
  },

  map: {
    border: COLOR.gray01,
    label: COLOR.darkGray,
    foreground: COLOR.white,
    tooltip: {
      border: COLOR.gray01,
      background: COLOR.white,
    },
  },
  barChartNoneColor: COLOR.blue12,

  countryColorDefault: COLOR.blue09,
}
